
















































import {
  computed,
  defineComponent,
  useStore,
  ref,
  watch,
} from '@nuxtjs/composition-api'
import { reactive } from '@vue/composition-api'
import TeleportV2 from '@/components/TeleportV2.vue'
import RgsModalAside from '@/components/RgsModalAside.vue'
import { IFrameOutput } from '@/contracts/IFrame'
import { useKeycloakAuthModal } from '@/composition/useAuthModal'

export default defineComponent({
  components: { RgsModalAside, TeleportV2 },
  setup() {
    const data = reactive({
      url: null,
      hostname: null,
    })
    const store = useStore()
    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])
    const iframeStopped = ref(false)
    const authModalData = computed(
      () =>
        store.getters['settings/getAuthModalData'][
          store.getters['modal/GET_MODAL']
        ]
    )
    const authModalNotice = computed(
      () => store.getters['settings/getAuthModalData']?.notice || ''
    )
    const isVisible = computed(() => {
      return (
        !iframeStopped.value &&
        !!store.getters['modal/GET_MODAL'] &&
        store.getters['modal/GET_MODAL'].includes('modal-auth') &&
        // modal-auth-account обслуживает AuthAccountModal
        store.getters['modal/GET_MODAL'] !== 'modal-auth-account'
      )
    })

    const { params, styles, onload } = useKeycloakAuthModal(isVisible)

    const iframeProps = reactive({
      width: '100%',
      height: '100%',
      sameOrigin: true,
      emitDelay: 100,
      src: computed(() => params.value?.src),
    })
    const modalProps = reactive({
      authTitle: computed(() => authModalData.value?.authTitle || 'Вход'),
      title: computed(() => authModalData.value?.title || 'Вход'),
      icon: computed(() => authModalData.value?.icon),
      link: computed(() => authModalData.value?.link),
    })
    const onUpdate = (iframeData: IFrameOutput) => {
      if (
        data.hostname &&
        iframeData.hostname &&
        data.hostname !== iframeData.hostname
      )
        window.location.assign(iframeData.url)
      data.hostname = iframeData.hostname
      data.url = iframeData.url
    }
    const onStop = () => {
      iframeStopped.value = true
      window.location.assign(params.value?.redirectUrl)
    }
    watch(isVisible, (value) => {
      if (!value) {
        iframeStopped.value = false
        data.hostname = null
        data.url = null
      }
    })

    return {
      modalProps,
      isVisible,
      iframeProps,
      onUpdate,
      onStop,
      onload,
      isMobile,
      authModalNotice,
      styles,
    }
  },
})
